const state = {
  googleAuthData: null,
}

const getters = {}

const mutations = {
  setGoogleAuthData(state, data){
    state.googleAuthData = data
  }
}

const actions = {
  'SET_GA_AUTH_DATA': ({commit}, data) => {
    commit('setGoogleAuthData', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
